module.exports = __webpack_public_path__ + "static/img/1-2.0241b80c.png";